
interface Props {
    score: number;
    onUpdate: (delta: number) => void;
    color: 'blue' | 'red';
    align?: 'left' | 'right';
}

export function ScoreboardWidget({ score, onUpdate, color, align = 'left' }: Props) {
    const btnColor = color === 'blue' ? 'bg-blue-600 hover:bg-blue-500' : 'bg-red-600 hover:bg-red-500';
    const textColor = color === 'blue' ? 'text-blue-400' : 'text-red-400';

    return (
        <div className={`flex flex-col ${align === 'right' ? 'items-end' : 'items-start'}`}>
            <div className="flex items-center gap-4">
                {/* Minus Button */}
                <button
                    onClick={() => onUpdate(-1)}
                    className="w-16 h-16 rounded-xl bg-slate-800 border-2 border-slate-700 flex items-center justify-center text-3xl font-bold text-slate-400 active:bg-slate-700 active:scale-95 transition-all touch-manipulation"
                >
                    -
                </button>

                {/* Score Display */}
                <div className={`text-6xl font-black ${textColor} tabular-nums min-w-[3ch] text-center tracking-tighter`}>
                    {score}
                </div>

                {/* Plus Button */}
                <button
                    onClick={() => onUpdate(1)}
                    className={`w-20 h-20 rounded-2xl ${btnColor} shadow-lg shadow-${color}-900/50 flex items-center justify-center text-4xl font-bold text-white active:scale-95 transition-all touch-manipulation border-b-4 border-black/20 active:border-b-0 active:translate-y-1`}
                >
                    +
                </button>
            </div>
        </div>
    );
}
